// extracted by mini-css-extract-plugin
module.exports = {"container":"_2lLeBl3","inline":"_22G4KfF"};